<template>
	<div>
        {{taskRecord}}
		<div class="col-md-12 header">
			<h5 class="mt-3 text-dark" style="color:#48a6a6 !important">{{task.title}} </h5>
			<div>
				<div class="text-dark" style="color:black !important;  " v-html="renderFormattedContent(task.description)"></div>
			</div>
		</div>
		
		<hr class="mb-2">
		<ul class="nav nav-pills nav-fill" role="tablist" id="tabs" style="font-size:14px;font-weight:500;">
			<li>
				<button style="padding: 5px 10px;" class="rounded mt-1" v-bind:class="[ tab==1 ? 'active' : '']" @click="tabs(1)">Information</button>
			</li>
			<li>
				<button style="padding: 5px 10px;" class="rounded mt-1" v-bind:class="[ tab==2 ? 'active' : '']" @click="tabs(2)">Support ticket details</button>
			</li>
			<li>
				<button style="padding: 5px 10px;" class="rounded mt-1" v-bind:class="[ tab==3 ? 'active' : '']" @click="tabs(3)">Due-Date History</button>
			</li>
			
			
		</ul>
		<hr>
			<div v-if="tab==1">
				<div class="row">
					<div class="col-6">
						<div>
							<span class="color-default font-weight-bold">Assign To</span>
							<br>
							<span style="color:black" v-if="task.assigned_to">
								{{ task.assigned_to.first_name }} {{ task.assigned_to.first_name }}
							</span>
							<span  v-else class="text-center">
									-----
							</span>
						</div>
					</div>
					<div class="col-6">
						<div>
							<span class="color-default font-weight-bold">Due Date</span>
							<br>
							<span style="color:black" v-if="task.due_date">
								{{ task.due_date | formatDate}}
							</span>
							<span  v-else class="text-center">
									-----
							</span>
						</div>
					</div>
				</div>
				<div class="row">    
					<div class="col-6">    
						<div>
							<span class="color-default font-weight-bold">Priority</span>
							<br>
							<span style="color:black">{{getPriorityName(task.priority)}}</span>
						</div>
					</div>
					<div class="col-6">
						<div>
							<span class="color-default font-weight-bold">Status</span>
							<br>
							<span style="color:black">{{getStatusName(task.status)}}</span>
						</div>
					</div>
				</div>
				<div class="row">    
					<div class="col-6">    
						<div>
							<span class="color-default font-weight-bold">Customers</span>
							<br>
							<span style="color:black">{{task.organization.map((item, index) => item.name).join(', ')}}</span>
						</div>
					</div>
					<div class="col-6">
						<div>
							<span class="color-default font-weight-bold">Open Date</span>
							<br>
							<span style="color:black">{{task.created_at | formatDate}}</span>
						</div>
					</div>
				</div>
			</div>
			<div v-if="tab==2"> 
				<div id="messages_container" class="col-sm 12 col-md-12 col-lg-12">
					<div class="row" v-for="(tm, index) in ticket_messages" :key="index">
						<div v-bind:class="{support_message: 1,from_admin: tm.sent_by_admin == 1,from_user: tm.sent_by_admin == 0}">
							<span class="message_time">{{tm.created_at | formatDateTime}}</span>
							<div class="user_logo">
								<img src="/blank-profile-picture.png" alt="Logo" width=""/>
								
								<!-- <img v-if="tm.sent_by_admin != 1 && tm.sent_by_admin !=0" :src="main_site_url + '/images/logo.png'" alt="Logo" />
								<img v-else :src="amazon_profile_url" alt="Logo" /> -->
							</div>
							<div class="message_content">
								<p class="message_para" v-html="tm.message" style=""></p>
								<div v-if="tm.attachments.length">
								<hr />
								<ul>
									<li v-for="(tma, index) in tm.attachments" :key="index">
									<a :href="amazonUrl+tma.path" target="_blank" :title="tma.name">
										<font-awesome-icon :icon="['fas', 'file-image']" size="3x" v-if="
											supportedImageFormats.includes(
											tma.name.substr(tma.name.lastIndexOf('.'))
											)
										" />
										<font-awesome-icon :icon="['fas', 'file-word']" size="3x" v-else-if="
											supportedDocumentFormats.includes(
											tma.name.substr(tma.name.lastIndexOf('.'))
											)
										" />
										<font-awesome-icon :icon="['fas', 'file-video']" size="3x" v-else-if="
											supportedVideoFormats.includes(
											tma.name.substr(tma.name.lastIndexOf('.'))
											)
										" />
										<font-awesome-icon :icon="['fas', 'file-audio']" size="3x" v-else-if="
											supportedAudioFormats.includes(
											tma.name.substr(tma.name.lastIndexOf('.'))
											)
										" />
										<font-awesome-icon :icon="['fas', 'tag']" size="3x" v-else />
										<span>{{ tma.name }} </span>
									</a>
									</li>
								</ul>
								</div>
							</div>
						</div>
					</div>
					<div v-if="ticket.length == 0" class="text-center"> No Record Found

					</div>
					<div id="messages_container_end"></div>
				</div>
			</div>
			<div v-if="tab==3">
				<ul class="col-md-12" >
					<li  v-for="(date,index) in activity" :key="index" class="color-default font-weight-bold py-3" style="border-bottom:1px solid rgba(0, 0, 0, 0.1);">
						<span v-if="index == 0">{{date.updated_by.first_name}} {{date.updated_by.last_name}} set due-date {{date.due_date}} on {{date.created_at | formatDateTime}}.</span>
						<span v-else>{{date.updated_by.first_name}} {{date.updated_by.last_name}} changed due-date from {{activity[index-1].due_date}} to {{date.due_date}} on {{date.created_at | formatDateTime}}.</span>
						<br>
						<span style="color:black !important; font-weight:400 !important">{{date.reason}}</span>
					</li>
					<li v-if="activity.length == 0" class="text-center" style="list-style-type:none !important;">
						<span >No Record Found</span>
					</li>
				</ul>
			</div>
		<!-- Informations -->
		



		<!-- Onboarding Questions -->
		

	</div>
</template>
<script>
	import axios from 'axios';
	import moment from 'moment';

	Vue.filter('formatDate', function (value) {
		if (value != '0000-00-00 00:00:00' && value != null) {
			return moment(String(value)).format('MMM DD, Y')
		}
	});
	 Vue.filter("formatDateTime", function (value) {
    if (value) {
      return (
        moment(String(value)).format("DD MMMM, YYYY") +
        " at " +
        moment(String(value)).format("hh:mm:ss A")
      );
    }
  });
	export default {
		props: [
			'formData'
		],
		data: function () {
			return {
				tab: 1,
				role:0,
				ticket:{},
				ticket_messages:{},
				activity:{},
                statusNames: {
                    0: 'Pending',
                    1: 'Assigned',
                    2: 'In Progress',
                    3: 'On Hold',
                    4: 'Delivered',
                },
                priorityNames:{
                    1: 'Normal',
                    2: 'Urgent',
                }
			};
		},
        // watch:{
        //     formData: function (){
        //         this.task = this.formData.task
        //     }
        // },
		computed: {
			 taskRecord: function () {
                this.task = this.formData.task.task;
                this.ticket = this.formData.task.ticket;
				if (this.ticket.messages)
                	this.ticket_messages = this.ticket.messages;
				else 
					this.ticket_messages = {};
                this.activity = this.formData.task.activity;
			},

		},
		mounted: function(){
			this.role= JSON.parse(localStorage.getItem('role'));
		},
		methods: {
			tabs(event) {
				if (event == 1) {
					this.tab = 1;
				} else if (event == 2) {
					this.tab = 2;
				} else if (event == 3) {
					this.tab = 3;
				}
				else if (event == 4) {
					this.tab = 4;
				}
			},
            getStatusName(status) {
                return this.statusNames[status] || 'Pending';
            },
            getPriorityName(status) {
                return this.priorityNames[status] || 'Normal';
            },
			renderFormattedContent(description) {
				const parser = new DOMParser();
				const doc = parser.parseFromString(description, "text/html");
				return doc.body.innerHTML;
			},
		}
	}
</script>
<style>
	#tabs .nav-link {
		background: transparent;
		color: rgb(66, 64, 64);
	}

	#tabs a:hover {}

	#tabs .active {
		background-color: #48a6a6 !important;
		color: white;
	}


	/* (A) "SET" THE TIMELINE CONTAINER */
	.vtl {
		/* (A1) RELATIVE POSITION NECESSARY TO PROPERLY POSITION TIMELINE LATER */
		position: relative;
		/* (A2) RESERVE MORE SPACE TO THE LEFT FOR THE TIMELINE */
		padding: 10px 0px 10px 50px;
		/* (A3) OPTIONAL WIDTH RESTRICTION */
		max-width: 1000px;
	}

	/* (B) DRAW TIMELINE USING ::BEFORE */
	.vtl::before {
		/* (B1) DRAW THE TIMELINE */
		content: '';
		width: 3px;
		background-color: #f4f8fa;
		/* (B2) POSITION IT TO THE LEFT */
		position: absolute;
		top: 0;
		bottom: 0;
		left: 15px;
	}

	/* (C) STYLES FOR THE EVENTS */
	div.event {
		padding: 20px 30px;
		background-color: #f2f5f7;
		position: relative;
		border-radius: 6px;
		margin-bottom: 10px;
	}

	/* (D) STYLES FOR THE DATE & TEXT */
	strong.edate {
		font-size: 14px;
		font-weight: bold;
		color: #48a6a6;
	}

	p.etxt {
		margin: 10px 0 0 0;
		color: #222;
	}

	/* (E) ADD "SPEECH BUBBLE TRIANGLE" TO THE EVENTS */
	div.event::before {
		content: '';
		border: 10px solid transparent;
		border-right-color: #f2f5f7;
		border-left: 0;
		position: absolute;
		top: 20%;
		left: -10px;
	}

	/* (F) ADD A CIRCLE ON THE TIMELINE TO INDICATE AN EVENT */
	div.event::after {
		content: '';
		background: #f4f8fa;
		border: 4px solid #48a6a6;
		width: 13px;
		height: 13px;
		border-radius: 50%;
		position: absolute;
		top: 25%;
		left: -40px;
	}
    .header{
        padding: 0% !important;
    }
	 #messages_container {
    overflow-y: scroll;
    max-height: 860px;
  }

  .support_message {
    margin-top: 15px;
    width: 100% !important;
  }

  .support_message.from_admin {
    margin-left: 10%;
	font-size: 12px!important
  }
  .support_message.from_user {
    margin-right: 10%;
	font-size: 12px!important
  }
  .support_message.from_user span.message_time {
    display: block;
    text-align: right;
  }

  .support_message.from_admin span.message_time {
    display: block;
    text-align: left;
  }

  .support_message .user_logo {
    float: left;
    overflow: hidden;
    border-radius: 50%;
    background: white;
  }

  .support_message.from_admin .user_logo {
    float: right;
    margin-right: 15px;
  }

  .support_message .user_logo img {
    width: 50px;
    height: 50px;
  }

  .support_message .message_content {
    position: relative;
    width: calc(100% - 75px);
    display: inline-block;
    margin-left: 25px;
    background: white;
    padding: 10px;
    border-radius: 0px 10px 10px 10px;
  }

  .support_message.from_admin .message_content {
    width: calc(100% - 90px);
    border: 0;
    border-radius: 10px 0px 10px 10px;
    float: right;
    margin: 0;
    margin-right: 25px;
    background: #48a6a6;
    color: white;
  }

  .support_message .message_content:before {
    content: "";
    position: absolute;
    height: 0;
    width: 0;
    right: 100%;
    top: 0;
    border: 15px solid transparent;
  }

  .support_message.from_user .message_content:before {
    border-right: 0 solid white;
    border-top: 20px solid white;
  }

  .support_message.from_admin .message_content:before {
    right: 0;
    left: 100%;
    border-left: 0 solid #22b9ff;
    border-top: 20px solid #22b9ff;
  }

  .support_message .message_content ul {
    margin: 0;
    padding: 0;
  }

  .support_message .message_content ul li {
    width: 25%;
    float: left;
    text-align: center;
    display: inline-block;
  }

  .support_message .message_content img,
  .support_message .message_content iframe {
    width: 200px !important;
    height: 200px !important;
  }

  .support_message .message_content ul li a {
    text-decoration: none;
    color: #0091d5;
    font-weight: 500;
  }

  .support_message.from_admin .message_content ul li a {
    color: white;
  }

  .support_message .message_content ul li a .attachment_icon {
    padding: 10px;
  }

  .support_message .message_content ul li a .attachment_icon i {
    font-size: 66px;
    color: #0091d5;
  }

  .support_message.from_admin .message_content ul li a .attachment_icon i {
    color: white;
  }

  .support_message .message_content ul li a span {
    width: 80px;
    overflow: hidden;
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
  }

  .support_message .message_content a:hover {
    color: #2739c1;
  }

  .support_message.from_admin .message_content a {
    color: black;
  }

  /* width */
  #messages_container::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  #messages_container::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  #messages_container::-webkit-scrollbar-thumb {
    background: #22b9ff;
  }

  /* Handle on hover */
  #messages_container::-webkit-scrollbar-thumb:hover {
    background: #43b3e7;
  }

  textarea {
    resize: vertical;
  }
</style>